/**
 * Minified by jsDelivr using Terser v5.39.0.
 * Original file: /gh/zuramai/mazer@docs/demo/assets/extensions/toastify-js/src/toastify.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
